export default "__VITE_PUBLIC_ASSET__5c03c81b__"